import { App, Controller } from './App'
import styles from './Timetable.module.css'

export class TimetableController implements Controller {
  private items: Element[]

  constructor(
    private readonly node: HTMLElement,
    private readonly app: App,
  ) {
    this.onIntersect = this.onIntersect.bind(this)

    this.items = Array.from(this.node.querySelectorAll(`.${styles.Item}`))

    this.app.on('intersect', this.onIntersect)
    this.items.forEach((item) => this.app.intersectionObserver.observe(item))
  }

  onIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry) => {
      if (this.items.includes(entry.target) && entry.isIntersecting) {
        entry.target.classList.add(`${styles.ItemVisible}`)
      }
    })
  }

  dispose() {
    this.app.removeListener('intersect', this.onIntersect)
    this.items.forEach((item) => this.app.intersectionObserver.unobserve(item))
  }
}
